import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Select } from 'antd';
import { STEP_TYPE } from '../../constants';
import { useTranslation } from 'react-i18next';

const SwapStopsToDriver = ({ state, handleOk, handleCancel, routes, solutions, orders, setMultipleStepState }) => {
  const { t } = useTranslation(['routes', 'common']);
  const [form] = Form.useForm();
  const [indexOptions, setIndexOptions] = useState([]);

  // Collect all orderIds from steps (handle both orderId and orderIds)
  const orderIds =
    state.steps?.reduce((acc, s) => {
      const ids = s.orderIds || (s.orderId ? [s.orderId] : []);
      return [...acc, ...ids];
    }, []) || [];

  const options = [
    {
      label: t('unscheduled'),
      value: 'unscheduled',
      isSelectIndex: false,
    },
  ];

  routes.forEach((route) => {
    options.push({
      value: route.driver.id,
      label: route.driver.name,
      isSelectIndex: true,
    });
  });

  const handleClick = () => {
    form.submit();
  };

  useEffect(() => {
    form.setFieldsValue({ toDriverId: state.toDriverId, index: state.index });
  }, [state]);

  const changeSolutionId = (value) => {
    setMultipleStepState({
      ...state,
      toDriverId: value,
      index: null,
    });
    if (value != 'unscheduled') {
      const newIndexOptions = [];
      solutions[value]?.forEach((ss, i) => {
        // Check if any orderId in ss matches any orderId in orderIds
        const ssOrderIds = ss.orderIds || (ss.orderId ? [ss.orderId] : []);
        if (ssOrderIds.some((id) => orderIds?.includes(id))) return;
        // For pickup, use first orderId; for delivery, use first orderId from orderIds
        const orderIdToFind = ss.type === STEP_TYPE.pickup ? ssOrderIds[0] : ssOrderIds[0];
        const order = orders.find((o) => o.id === orderIdToFind);
        newIndexOptions.push({
          value: i,
          label: `[${ss.index}] ${ss.type === STEP_TYPE.pickup ? order.pickupAddress : order.deliveryAddress}`,
        });
      });
      setIndexOptions(newIndexOptions || []);
    } else {
      setIndexOptions([]);
    }
  };

  const changeIndexValue = (value) => {
    setMultipleStepState({
      ...state,
      index: value,
    });
  };

  return (
    <Modal
      open={state.visibleModal}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t('swapStops.cancel')}
        </Button>,
        <Button key="submit" type="primary" onClick={handleClick}>
          {t('common:apply')}
        </Button>,
      ]}
      width={370}
      className="swap-driver-modal"
      closeIcon={false}
      forceRender
    >
      <div className="SwapStopsToDriver">
        <Form form={form} scrollToFirstError hideRequiredMark colon={false} layout="vertical" onFinish={handleOk}>
          <div className="FormContent">
            <Form.Item
              label={t('swapStops.driver')}
              name="toDriverId"
              rules={[{ required: true, message: t('common:required') }]}
            >
              <Select placeholder={t('swapStops.drivers')} onChange={changeSolutionId}>
                {options.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {state.toDriverId && indexOptions.length > 0 && (
              <Form.Item
                label={t('swapStops.after')}
                name="index"
                rules={[{ required: true, message: t('common:required') }]}
              >
                <Select
                  placeholder={t('swapStops.index')}
                  onChange={changeIndexValue}
                  filterOption={(input, option) => {
                    return (option?.key?.toLowerCase() ?? '')?.includes(input?.toLowerCase());
                  }}
                  dropdownStyle={{ minWidth: 550 }}
                  showSearch
                >
                  <Select.Option value={-1}>[0] {t('swapStops.start')}</Select.Option>
                  {indexOptions.map((item) => (
                    <Select.Option key={item.label} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default SwapStopsToDriver;
